// Testnet presentation helpers shared by the app chrome and purchase
// surfaces. The warning strip belongs in the live beta, but not inside the
// scripted tutorial's production-UI iframe.

import { CHAIN } from '../app/chain-config.js';

export const BASE_SEPOLIA_FAUCET_URL = 'https://www.alchemy.com/faucets/base-sepolia';

// Most Sepolia faucets now demand ~0.001 ETH on mainnet first (Google Cloud,
// Alchemy), which a brand-new wallet never has. The proof-of-work faucet asks
// for nothing but a few minutes of browser mining and pays out >= 0.05 ETH,
// far more than testnet play (prices scaled down 10^6) plus gas will use.
export const ETH_SEPOLIA_FAUCET_URL = 'https://sepolia-faucet.pk910.de/';

export function isBaseSepolia(chain = CHAIN) {
  return Number(chain?.id) === 84_532;
}

/** The free-test-ETH faucet for the configured testnet, or null off testnet. */
export function testnetFaucet(chain = CHAIN) {
  if (isBaseSepolia(chain)) return { url: BASE_SEPOLIA_FAUCET_URL, network: 'Base Sepolia', source: 'Alchemy faucet' };
  if (Number(chain?.id) === 11_155_111) return { url: ETH_SEPOLIA_FAUCET_URL, network: 'Ethereum Sepolia', source: 'proof-of-work faucet' };
  return null;
}

export function isTestnet(chain = CHAIN) {
  return testnetFaucet(chain) != null;
}

export function isTutorialApp(search = '') {
  try { return new URLSearchParams(String(search || '')).get('tutorial') === '1'; }
  catch (_e) { return false; }
}

export function syncTestnetBetaBanner({
  documentRef,
  locationRef,
  chain = CHAIN,
} = {}) {
  const doc = documentRef || (typeof document !== 'undefined' ? document : null);
  const loc = locationRef || (typeof window !== 'undefined' ? window.location : null);
  const banner = doc?.getElementById?.('testnet-beta-banner');
  if (!banner) return false;
  const faucet = testnetFaucet(chain);
  const show = faucet != null && !isTutorialApp(loc?.search || '');
  banner.hidden = !show;
  const link = banner.querySelector?.('.testnet-beta-banner__faucet');
  if (faucet && link) {
    link.setAttribute('href', faucet.url);
    link.setAttribute('aria-label', `Get free play money from the ${faucet.network} ${faucet.source}`);
  }
  return show;
}

if (typeof document !== 'undefined') syncTestnetBetaBanner();
